import { AuthModalMiddle } from './AuthModal';
import useStore from '../stores/store';
import useCustomToast from './ToastProvider';
import { Suspense, lazy, useEffect } from 'react';
import { useRemindersStore } from '../stores/remindersStore';
import DesktopShortcutProvider from './DesktopShortcutKeysProvider';
import TabsHandlerProvider from '../../platformFiles/TabHandlerProvider';
import layoutStore from '../stores/layoutStore';

const RemindersModal = lazy(() => import('./RemindersModal'));
const BookmarksModal = lazy(
    () => import('../../platformFiles/components/BookmarksModal')
);
const TabModal = lazy(() => import('./TabModal'));
const EditCatModal = lazy(() => import('./EditCatModal'));
const LimitReachedModal = lazy(() => import('./LimitReachModal'));
const WorkspaceShareModal = lazy(() => import('./WorkspaceShareModal'));
const BinDrawer = lazy(() => import('./BinDrawer'));
const SearchModal = lazy(() => import('./SearchModal'));
const FeedbackModal = lazy(() => import('./FeedbackModal'));

const ModalProvider = () => {
    const isRemindersModalOpen = useRemindersStore(
        (state: { isRemindersModalOpen: boolean }) => state.isRemindersModalOpen
    );
    const showCatModal = layoutStore((state) => state.showCatModal);
    const siteModalOpen = layoutStore((state) => state.siteModalOpen);
    const showBookmarksModal = layoutStore((state) => state.showBookmarksModal);
    const showLimitModal = layoutStore((state) => state.showLimitModal);
    const showShareModal = layoutStore((state) => state.showShareModal);
    const showBinDrawer = layoutStore((state) => state.showBinDrawer);
    const showSearchModal = layoutStore((state) => state.showSearchModal);
    const showFeedbackModal = layoutStore((state) => state.showFeedbackModal);

    const modalsMapping = [
        { isModalOpen: isRemindersModalOpen, ModalComponent: RemindersModal },
        { isModalOpen: showBookmarksModal, ModalComponent: BookmarksModal },
        { isModalOpen: siteModalOpen, ModalComponent: TabModal },
        { isModalOpen: showCatModal, ModalComponent: EditCatModal },
        { isModalOpen: showLimitModal, ModalComponent: LimitReachedModal },
        { isModalOpen: showShareModal, ModalComponent: WorkspaceShareModal },
        { isModalOpen: showBinDrawer, ModalComponent: BinDrawer },
        { isModalOpen: showSearchModal, ModalComponent: SearchModal },
        { isModalOpen: showFeedbackModal, ModalComponent: FeedbackModal }
    ];

    const showToast = useCustomToast();
    const toastState = useStore((state) => state.toastState);

    useEffect(() => {
        if (toastState) {
            showToast({
                title: toastState.title,
                type: toastState.type,
                subtitle: toastState.subtitle,
                resClick: toastState.resClick
            });
        }
    }, [toastState]);

    return (
        <>
            <TabsHandlerProvider />
            {!isRemindersModalOpen && <DesktopShortcutProvider />}
            <AuthModalMiddle />
            {modalsMapping.map(({ isModalOpen, ModalComponent }, index) =>
                isModalOpen ? (
                    <Suspense key={index} fallback={null}>
                        <ModalComponent />
                    </Suspense>
                ) : null
            )}
        </>
    );
};

export default ModalProvider;
